export default __webpack_public_path__ + "static/chart_engagement-9d115e247c9f82d3174151ce1edac564.svg";